<template>
  <div class="content">
    <div class="search-area"  v-if="dataList != null && dataList.length > 0"> 
    <!-- {{dataList}} -->
         <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">计算的参数值</h3>
         <div v-for="da in dataList" class="t-left" style="margin-top: 5px;">{{da}}</div>
    </div>
    <div class="search-area mt15 t-left"  v-if="repositoryDescription != null && repositoryDescription != ''"> 
    <!-- {{dataList}} -->
         <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">算法名词解释</h3>
         {{repositoryDescription}}
         <!-- <div v-for="da in dataList" class="t-left" style="margin-top: 5px;">{{da}}</div> -->
    </div>
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <!-- <div class="button-area">
      <el-button icon="el-icon-s-data" size="medium" type="info" @click="classify">按省汇总</el-button>
    </div> -->
    <div class="back-color-fff p16 mt15">
    <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">计算结果</h3>
    <el-tabs v-model="activeName">
        <el-tab-pane label="地图" name="first">
                <div v-if="tableData == null || tableData == ''">暂无数据！</div>
                <div class="echarts" id="mapBox" :style="height"></div> 
        </el-tab-pane>
        <el-tab-pane label="表格" name="second">
                <el-table
                :data="tableDatas"
                border
                style="width: 100%;">  
                <el-table-column
                  prop="rdcLocationCity"
                  label="RDC所在城市"
                  align="center" header-align="center" width="120"> 
                </el-table-column> 
                <el-table-column
                  prop="coverageProvinceShort"
                  label="覆盖省份"
                  align="center" header-align="center" show-overflow-tooltip> 
                  <template slot-scope="scope">{{ scope.row.coverageProvinceShort}}</template>
                </el-table-column> 
                <el-table-column
                  prop="coverageArea"
                  label="覆盖城市"
                  align="center" header-align="center">  
                  <template slot-scope="scope">{{ scope.row.coverageArea | roleNames}}</template>
                </el-table-column> 
              </el-table>
        </el-tab-pane> 
      </el-tabs>
      
       
  </div>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';

export default {
  data() {
    return {
      options: areaJson,
      page: {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        yearSalesRanking: '',
        newOldCostRate:'',
        year: '',
      },
      activeName: 'first',
      winHeight: window.innerHeight,
      height: {
        height: '',
      },
      dataList:'',
      rankingList:[{
          value: '1',
          label: '前1名'
        },{
          value: '2',
          label: '前2名'
        }, {
          value: '3',
          label: '前3名'
        }, {
          value: '4',
          label: '前4名'
        }, {
          value: '5',
          label: '前5名'
        },{
          value: '6',
          label: '前6名'
        }, {
          value: '7',
          label: '前7名'
        }, {
          value: '8',
          label: '前8名'
        }, {
          value: '9',
          label: '前9名'
        }, {
          value: '10',
          label: '前10名'
        }],
      costList:[{
          value: '2',
          label: '小于2'
        }, {
          value: '3',
          label: '小于3'
        }, {
          value: '4',
          label: '小于4'
        }],
      repositoryDescription:'',
      dialogTableVisible: false,
      tableData: [],
      tableDatas:[],
      classifyList: [],
      timeList: '',
      timeListS: '',
      customerCount: 0,
      franchiseeCount: 0,
      sumAmount: 0,
      totalGoodsSpecNum: 0,
      loading:false,
      value1:'',
      data:[],
        geoCoordMap:{},
        regions:[//给每个省份的区域加上背景色
                {
                    name: '南海诸岛',
                    itemStyle: {
                        areaColor: '#6F798D',
                        opacity: 0.5
                    }
                },
                {
                    name: '北京', 
                    itemStyle: {
                        areaColor: '#034DE4',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '天津', 
                    itemStyle: {
                        areaColor: '#034DE4',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '上海', 
                    itemStyle: {
                        areaColor: '#27E9FD',
                        opacity: 0.2                            
                    }                        
                },
                {
                    name: '重庆', 
                    itemStyle: {
                        areaColor: '#0E7DEB',
                        opacity: 0.2                            
                    }                  
                },
                {
                    name: '河北', 
                    itemStyle: {
                        areaColor: '#034DE4',
                        opacity: 0.2                            
                    }                                      
                },
                {
                    name: '河南', 
                    itemStyle: {
                        areaColor: '#034DE4',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '云南', 
                    itemStyle: {
                        areaColor: '#20CAF8',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '辽宁', 
                    itemStyle: {
                        areaColor: '#034DE4',
                        opacity: 0.2                            
                    }                    
                },
                {
                    name: '黑龙江', 
                    itemStyle: {
                        areaColor: '#17A3F1',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '湖南', 
                    itemStyle: {
                        areaColor: '#0554E4',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '安徽', 
                    itemStyle: {
                        areaColor: '#27E8FD',
                        opacity: 0.2                            
                    }                  
                },
                {
                    name: '山东', 
                    itemStyle: {
                        areaColor: '#4BFFFF',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '新疆', 
                    itemStyle: {
                        areaColor: '#17A3F1',
                        opacity: 0.2                            
                    }
                },
                {
                    name: '江苏', 
                    itemStyle: {
                        areaColor: '#00b6f6',
                        opacity: 0.2                            
                    }                  
                },
                {
                    name: '浙江', 
                    itemStyle: {
                        areaColor: '#00b6f6',
                        opacity: 0.2                            
                    }                    
                },
                {
                    name: '江西', 
                    itemStyle: {
                        areaColor: '#01a4f1',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '湖北', 
                    itemStyle: {
                        areaColor: '#005ce5',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '广西', 
                    itemStyle: {
                        areaColor: '#0088ec',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '甘肃', 
                    itemStyle: {
                        areaColor: '#0042df',
                        opacity: 0.2                            
                    }                                       
                },
                {
                    name: '山西', 
                    itemStyle: {
                        areaColor: '#01d0fa',
                        opacity: 0.2                            
                    }                     
                },
                {
                    name: '内蒙古', 
                    itemStyle: {
                        areaColor: '#00ccf7',
                        opacity: 0.2                            
                    }                                       
                },
                {
                    name: '陕西', 
                    itemStyle: {
                        areaColor: '#01b0f3',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '吉林', 
                    itemStyle: {
                        areaColor: '#0051e1',
                        opacity: 0.2                            
                    }                                       
                },
                {
                    name: '福建', 
                    itemStyle: {
                        areaColor: '#0158e3',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '贵州', 
                    itemStyle: {
                        areaColor: '#0199ef',
                        opacity: 0.2                            
                    }                    
                },
                {
                    name: '广东', 
                    itemStyle: {
                        areaColor: '#00d9fc',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '青海', 
                    itemStyle: {
                        areaColor: '#005ae4',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '西藏', 
                    itemStyle: {
                        areaColor: '#01e9fd',
                        opacity: 0.2                            
                    }                    
                },
                {
                    name: '四川', 
                    itemStyle: {
                        areaColor: '#0069e8',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '宁夏', 
                    itemStyle: {
                        areaColor: '#01b0f3',
                        opacity: 0.2                            
                    }                    
                },
                {
                    name: '海南', 
                    itemStyle: {
                        areaColor: '#00f0ff',
                        opacity: 0.2                            
                    }                   
                },
                {
                    name: '台湾', 
                    itemStyle: {
                        areaColor: '#0067e7',
                        opacity: 0.2                            
                    }                                      
                },
                {
                    name: '香港', 
                    itemStyle: {
                        areaColor: '#00dafa',
                        opacity: 0.2                            
                    } 
                },
                {
                    name: '澳门', 
                    itemStyle: {
                        areaColor: '#00dafa',
                        opacity: 0.2                            
                    } 
                } 
            ]
    };
  },
  created() {
    // 列表
    let self = this; 
    let list = '';
    let canList = [];
     if(self.$router.history.current.query.list != null){
          list = JSON.parse(self.$router.history.current.query.list);   
          for(let i in list){ 
            let z = i +'：'+ list[i]
            canList.push(z); 
          }
    }
    if(self.$router.history.current.query.repositoryDescription != null){
          self.repositoryDescription = JSON.parse(self.$router.history.current.query.repositoryDescription);    
    } 
    console.log(canList);
    self.dataList = canList;
    // self.page.newOldCostRate = self.$router.history.current.query.newOldCostRate;
    // self.page.yearSalesRanking = self.$router.history.current.query.yearSalesRanking;
    // self.page.year = self.$router.history.current.query.year;
    self.getData(false);  
  },
    mounted(){     
    window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-545+'px';
  }, 
  methods: {
    empty() {
      let self = this;
      self.timeList = '';
      self.timeListS = '';
      self.page = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        newOldCostRate:'',
        yearSalesRanking: '',
        year: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1; 
      } 
      if(self.page.year != ''){
            self.page.year = self.$moment(self.page.year).format('YYYY');
      } 
      self.data = [];
      self.geoCoordMap = {};
      let arr = [];
      self.page.mathConditionGuid = self.$router.history.current.query.guid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/siting-result/data/get`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          self.tableData = res.data.data.records;
          if(self.tableData != null){
              let map = new Map();
              self.tableData.forEach(function (i,index) { 
                    let item = {
                        name: i.rdcLocationCity, 
                        value: 100
                    }
                    self.data.push(item);
                    let item1 = {
                        name: i.rdcLocationCity, 
                        rdcLng: i.rdcLng,
                        rdcLat:i.rdcLat
                    }
                    arr.push(item1);
              });
              arr.map(j=>{
                    self.geoCoordMap[j.name] = [j.rdcLng,j.rdcLat]
                })
              console.log(self.data);
              console.log(self.geoCoordMap);
              // console.log(self.data); 
              self.myChartsss();  
              self.page.totalPage = res.data.data.totalPages;
              self.page.totalRows = res.data.data.totalRows;
          }
          self.getTableData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTableData() {
      let self = this;
      self.loading = true; 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/siting-result/data/get`,{'page':1,'pageSize':-1,'newOldCostRate':self.page.newOldCostRate,'yearSalesRanking':self.page.yearSalesRanking,'year':self.page.year,'mathConditionGuid':self.$router.history.current.query.guid}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          self.tableDatas = res.data.data.records;
          if(self.tableDatas != null){
                    let map = new Map();
                      self.tableDatas.forEach(function (i,index) {
                            i.coverageProvinceShort =JSON.parse(i.coverageProvinceShort);
                            i.coverageProvinceShort = i.coverageProvinceShort.toString();
                            i.coverageArea =JSON.parse(i.coverageArea);
                            i.coverageArea = i.coverageArea.toString(); 
                      });    
          } 
          console.log(self.tableDatas);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    strMapToObj(strMap){
        let obj= Object.create(null);
        for (let[k,v] of strMap) {
            obj[k] = v;
        }
        return obj;
    },

    myChartsss() {
      let self = this;
       var chartDom = document.getElementById('mapBox');
      var myChart = self.$echarts.init(chartDom);
      var convertData = function (data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
              var geoCoord = self.geoCoordMap[data[i].name];
              if (geoCoord) {
                  res.push({
                      name: data[i].name,
                      value: geoCoord.concat(data[i].value)
                  });
              }
          }
          return res;
      };
      var option = {
          // title: {
          //     text: '全国主要城市空气质量 - 百度地图',
          //     // subtext: 'data from PM25.in',
          //     // sublink: 'http://www.pm25.in',
          //     left: 'center'
          // },
          // tooltip : {
          //     trigger: 'item'
          // },
          // geo: {//城市地图
          //       map: 'china',
          //       show: true,
          //       roam: true,//禁止拖拽和伸缩 true为可拖拽
          //       label: {
          //           emphasis: {
          //               show: false
          //           }
          //       },
          //       itemStyle: {
          //           normal: {//地图背景色
          //               areaColor: '#034DE4',
          //               opacity: 0.5                    
          //           },
          //           emphasis: {//鼠标放上去区域背景色
          //               areaColor: "#034DE4",
          //               opacity: 0.5
          //           }
          //       },
          //       regions: self.regions //地图上每个省份标不同颜色
          //   },

          bmap: {
              map: 'china',
              show: true,
              center: [104.114129, 37.550339],
              zoom: 5,
              roam: true,
              mapStyle: {
                  styleJson: [{
                      'featureType': 'water',
                      'elementType': 'all',
                      'stylers': {
                          'color': '#d1d1d1'
                      }
                  }]
              }
          }, 
          series : [
              {
                  name: 'pm2.5',
                  type: 'scatter',
                  coordinateSystem: 'bmap',
                  data: convertData(self.data),
                  symbolSize: function (val) {
                      return val[2] / 5;
                  },
                  encode: {
                      value: 2
                  },
                  label: {
                      formatter: '{b}',
                      position: 'right',
                      show: false,
                  }, 
                  emphasis: {
                      label: {
                          show: true
                      }
                  }
              },
              {
                  name: 'Top 5',
                  type: 'effectScatter',
                  coordinateSystem: 'bmap',
                  // data: convertData(self.data.sort(function (a, b) {
                  //     return b.value - a.value;
                  // }).slice(0, 1)),
                  symbolSize: function (val) {
                      return val[2] / 5;
                  },
                  encode: {
                      value: 2
                  },
                  showEffectOn: 'render',
                  rippleEffect: {
                      brushType: 'stroke'
                  },
                  hoverAnimation: true,
                  label: {
                      formatter: '{b}',
                      position: 'right',
                      show: true
                  },
                  itemStyle: {
                      shadowBlur: 10,
                      shadowColor: '#333'
                  },
                  zlevel: 1
              }
          ]
      };
      myChart.setOption(option);
    },
    getDataTotal() {
      let self = this;
      if (
        self.timeList &&
        Array.isArray(self.timeList) &&
        self.timeList.length > 0 &&
        self.timeList[0] &&
        self.timeList[1]
      ) {
        self.page.startTime = self.$moment(self.timeList[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.endTime = self.$moment(self.timeList[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.startTime = '';
        self.page.endTime = '';
      }
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msPurchaseService}/order/data/get-total`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.customerCount = res.data.data.customerCount;
          self.franchiseeCount = res.data.data.franchiseeCount;
          self.sumAmount = res.data.data.sumAmount;
          self.totalGoodsSpecNum = res.data.data.totalGoodsSpecNum;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    classify() {
      let self = this;
      self.dialogTableVisible = true;
      self.getDataClassify(true);
    },
    getDataClassify(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (self.timeList == '') {
        self.timeList = self.timeListS;
      }
      if (
        self.timeList &&
        Array.isArray(self.timeList) &&
        self.timeList.length > 0 &&
        self.timeList[0] &&
        self.timeList[1]
      ) {
        self.page.startTime = self.$moment(self.timeList[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.endTime = self.$moment(self.timeList[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.startTime = '';
        self.page.endTime = '';
      }
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msPurchaseService}/order/data/get-classify`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.classifyList = res.data.data;
          self.classifyList.forEach(function (i) {
            areaJson.forEach(function (j) {
              if (i.province == j.value) {
                i.province = j.label;
              }
            });
          });
          let provinceList = [];
          let amountList = [];
          self.classifyList.forEach(function (i) {
            if (i.province != '' && i.province != null) {
              provinceList.unshift(i.province);
              amountList.unshift(i.sumTotalQty);
            }
          });
          // self.myChart(provinceList, amountList);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    detail(guid) {
      this.$router.push({ path: '/orderInquiry/detail', query: { guid: guid , productGuid:this.$route.query.productGuid} });
    },
     
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
</script>
<style scoped>
.el-range-editor.el-input__inner {
  padding: 0px;
}
.w70f {
  width: 70%;
}
</style>